const features = [
  {
    icon: 'ri-vip-diamond-line',
    title: '完全免费',
    desc: '无需付费、无需注册、无需订阅会员，所有影视内容全部免费观看，零成本畅享海量资源。',
  },
  {
    icon: 'ri-4k-line',
    title: '全高清画质',
    desc: '支持1080P全高清播放，清晰流畅的画面呈现每一个细节，带来影院级观影体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '秒播不缓冲',
    desc: '采用智能CDN加速技术，视频秒开秒播，告别加载等待，追剧体验一气呵成。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '每日更新超过30部影视内容，最新剧集、电影第一时间上线，追更永不掉队。',
  },
  {
    icon: 'ri-global-line',
    title: '全球覆盖',
    desc: '内容覆盖日本、韩国、欧美、国产等12个国家和地区，满足不同观众的多样化观影需求。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              平台优势
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              为什么选择樱花TV？五大优势给你答案
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {features.map((feature) => (
              <div
                key={feature.title}
                className="text-center bg-background-50 rounded-lg border border-background-200/60 p-6 hover:border-primary-200 transition-all duration-300"
              >
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                  <i className={`${feature.icon} text-2xl`} />
                </div>
                <h3 className="mt-4 text-base font-semibold text-foreground-900">
                  {feature.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-600 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}